import {
  Box,
  Button,
  ButtonProps,
  Image,
  Typography,
  useTheme
} from "@outschool/backpack";
import React from "react";

type BlobButtonProps = {
  imageSrc: string;
  title: string;
} & ButtonProps;

export const BlobButton = ({
  title,
  imageSrc,
  ...buttonProps
}: BlobButtonProps) => {
  const theme = useTheme();

  return (
    <Button
      variant="link"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        color: theme.palette.common.black,
        textDecoration: "none !important",
        "&:hover": {
          color: theme.palette.primary.light
        }
      }}
      {...buttonProps}
    >
      <Image
        src={imageSrc}
        sx={{
          maxWidth: theme.typography.pxToRem(120),
          maxHeight: theme.typography.pxToRem(108)
        }}
      />
      <Box
        sx={{
          maxWidth: "12rem",
          textAlign: "center",
          whiteSpace: "normal"
        }}
      >
        <Typography
          variant="inherit"
          sx={{
            fontSize: theme.typography.pxToRem(14),
            fontWeight: 400
          }}
        >
          {title}
        </Typography>
      </Box>
    </Button>
  );
};
